<template>
	<v-avatar class="avatar" color="warm-blue" :size="size">
		<template v-if="user.profileUrl">
			<!-- Show user profile image -->
			<img :src="user.profileUrl" />
		</template>
		<template v-else-if="user.initials">
			<!-- Show user initials -->
			<span class="initials white--text" :style="{ fontSize: `${fontSize}px` }">
				{{ user.initials }}
			</span>
		</template>
		<template v-else>
			<!-- Show generic user icon -->
			<v-icon class="user-icon" color="white" :size="fontSize">
				fas fa-user
			</v-icon>
		</template>
	</v-avatar>
</template>

<style lang="scss" scoped>
.avatar .initials {
	text-transform: uppercase;
	font-weight: 500;
	font-family: "Roboto", sans-serif;
}
</style>

<script>
export default {
	props: {
		color: {
			type: String,
			default: "warm-blue",
		},
		size: {
			type: Number,
			default: 84,
		},
		user: {
			type: Object,
			required: true,
		},
	},

	computed: {
		fontSize() {
			return this.size / 2.75;
		},
	},
};
</script>
